<template>
  <div class="collapse-wrap">
    <!-- <h4 class="title">
      <span class="title-name">{{ title }}</span>
      <span class="arrow-icon-box" @click="showMore = !showMore">
        <span class="vlm">{{ showMore ? LANG.hide : LANG.more1 }}</span>
        <i class="icon arrow-icon vlm pd-l-xs">{{ showMore ? '&#xe892;' : '&#xe87e;' }}</i>
      </span>
    </h4> -->
    <div v-show="showMore">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title'],
  data() {
    return {
      showMore: true
    }
  }
}
</script>


<style lang="scss" scoped>
.collapse-wrap {
  .title {
    display: flex;
    justify-content: space-between;
    &-name {
      font-weight: 700;
      font-size: 16px;
    }
    .arrow-icon-box {
      cursor: pointer;
      font-size: 12px;
      .arrow-icon {
        font-size: 12px;
      }
    }
  }
}
</style>